import { createFileRoute } from "@tanstack/react-router";
import { noindexHead } from "@/features/marketing/seo";
import { RsvpPublicPage } from "@/features/rsvp/rsvp-public-page";
import { t } from "@/i18n";

/**
 * /rsvp/:token — a guest's reply page. Public (the token is the credential), no session lookup, no prerender,
 * not indexed (meta here + x-robots-tag from the Worker), and it stores nothing on the device.
 */
export const Route = createFileRoute("/rsvp/$token")({
  head: () => noindexHead(t("marketing.seo.rsvp")),
  component: () => {
    const { token } = Route.useParams();
    return <RsvpPublicPage token={token} />;
  },
});
